import { motion, type Easing } from "motion/react"
import { type ReactNode } from "react"

interface ShowHideContainerProps {
  children: ReactNode
  isVisible: boolean
  className?: string
  duration?: number
  ease?: Easing
}

export function ShowHideContainer({
  children,
  isVisible,
  className,
  duration = 0.2,
  ease = "easeInOut",
}: ShowHideContainerProps) {
  return (
    <motion.div
      initial={false}
      animate={{ height: isVisible ? "auto" : 0, opacity: isVisible ? 1 : 0 }}
      transition={{ duration, ease }}
      style={{ overflow: isVisible ? "visible" : "hidden" }}
      className={className}
      aria-hidden={!isVisible}
    >
      {children}
    </motion.div>
  )
}
